import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule as MyCommonModule} from './common/common.module';
import {HttpLoaderFactory, I18nModule} from './common/i18n/i18n.module';
import {AUTH_INTERCEPTOR_PROVIDER} from './common/auth/interceptors/auth-interceptor.provider';
import {AuthGuard} from './common/auth/guards/auth.guard';
import {AuthenticationService} from './common/auth/authentication.service';
import {RoleGuard} from './common/auth/guards/role.guard';
import {CookieService} from 'ngx-cookie-service';
import {AppRedirectService} from './common/auth/app-redirect.service';
import {
    MissingTranslationHandler,
    TranslateLoader,
    TranslateModule,
    TranslateParser,
    TranslatePipe,
} from '@ngx-translate/core';
import {PercentageSignTranslateParser} from "./common/i18n/percentage-sign-translate-parser";
import {AppMissingTranslationService} from "./common/i18n/app-missing-translation.service";
import {MessagesModule} from 'primeng/messages';
import {ToastModule} from 'primeng/toast';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {MessageService} from 'primeng/api';
import { BuildingService } from './application/services/building.service';
import {AppThemeModule} from './application/theme/app-theme.module';
import { SemaphoreComponent } from './application/semaphore-page/semaphore-page.component';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { CardReaderComponent } from './application/components/card-reader/card-reader.component';
import { PersonSearchComponent } from './application/components/person-search/person-search.component';
import { LogsTableComponent } from './application/components/logs-table/logs-table.component';
import { PersonInfoComponent } from './application/components/person-info/person-info.component';
import { SemaphoreCircleComponent } from './application/components/semaphore-circle/semaphore-circle.component';
import { AdminPanelPageComponent } from './application/admin-panel-page/admin-panel-page.component';
import { RoleAssignmentComponent } from './application/components/role-assignment/role-assignment.component';
import { UserTableComponent } from './application/components/user-table/user-table.component';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { CheckInLogsPageComponent } from './application/check-in-logs-page/check-in-logs-page.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DashboardPage } from './application/dashboard-page/dashboard-page.component';
import { CardIndicatorComponent } from './application/components/card-indicator/card-indicator.component';
import { MobileAppPageComponent } from './application/mobile-app-page/mobile-app-page.component';
import { InstallationDialogComponent } from './application/components/installation-dialog/installation-dialog.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { VisitPopupComponent } from './application/components/visit-popup/visit-popup.component';
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MyCommonModule,
        I18nModule,
        TranslateModule.forRoot(
            {
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
                parser: {
                    provide: TranslateParser,
                    useClass: PercentageSignTranslateParser,
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useExisting: AppMissingTranslationService,
                },
            },
        ),
        MessagesModule,
        ButtonModule,
        CardModule,
        InputTextModule,
        ReactiveFormsModule,
        ToastModule,
        ProgressSpinnerModule, 
        AppThemeModule,
        PaginatorModule,
        TableModule,
        TagModule,
        DropdownModule,
        ToolbarModule,
        MultiSelectModule,
        TabViewModule,
        CalendarModule,
        DialogModule,
        DynamicDialogModule,
        RadioButtonModule,
        CheckboxModule,
        CardIndicatorComponent
    ],
    declarations: [
        AppComponent,
        SemaphoreComponent,
        CardReaderComponent,
        PersonSearchComponent,
        LogsTableComponent,
        PersonInfoComponent,
        SemaphoreCircleComponent,
        AdminPanelPageComponent,
        RoleAssignmentComponent,
        UserTableComponent,
        CheckInLogsPageComponent,
        MobileAppPageComponent,
        InstallationDialogComponent,
        VisitPopupComponent
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        AUTH_INTERCEPTOR_PROVIDER,
        AuthGuard,
        RoleGuard,
        AuthenticationService,
        CookieService,
        AppRedirectService,
        MessageService,
        TranslatePipe,
        BuildingService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
